// extracted by mini-css-extract-plugin
export default {"card-profile-stats":"Profile_card-profile-stats__-DBAI","email":"Profile_email__6gnZy","location":"Profile_location__BaFPE","calendar":"Profile_calendar__NYGT3"};